import { render, staticRenderFns } from "./QuotationTemplate.vue?vue&type=template&id=3df08006&scoped=true"
import script from "./QuotationTemplate.vue?vue&type=script&lang=js"
export * from "./QuotationTemplate.vue?vue&type=script&lang=js"
import style0 from "./QuotationTemplate.vue?vue&type=style&index=0&id=3df08006&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3df08006",
  null
  
)

export default component.exports